import { filterUsernameInput } from '@ltvco/refresh-lib/utils';
import {
  Control,
  FieldErrors,
  UseFormRegister,
} from '@ltvco/refresh-lib/vendors';
import React from 'react';

import { SearchInput } from '../SearchInput';

import { UsernameFormData } from './UsernameSearch';

interface UsernameInputProps {
  register: UseFormRegister<{ username: string }>;
  placeholder: string;
  errors: FieldErrors<{ username: string }>;
  clearErrors: (field?: string) => void;
  onClear: () => void;
  value: string;
  control: Control<UsernameFormData>;
}

export const UsernameInput = React.memo(
  ({
    register,
    placeholder,
    errors,
    clearErrors,
    onClear,
    value,
    control,
  }: UsernameInputProps) => {
    const registerReturn = register('username');

    const handleUsernameInputChange = (
      e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
      field: { onChange: (value: string) => void }
    ) => {
      const input = e.target.value;
      const filteredValue = filterUsernameInput(input);
      field.onChange(filteredValue);

      if (filteredValue.trim()) {
        clearErrors('username');
      }
    };

    return (
      <SearchInput
        registerReturn={registerReturn}
        label="Username"
        placeholder={placeholder}
        error={errors.username}
        clearErrors={clearErrors}
        onClear={onClear}
        value={value}
        control={control as unknown as Control}
        fieldName="username"
        autoFocus
        customOnChange={handleUsernameInputChange}
      />
    );
  }
);
